export default __webpack_public_path__ + "static/media/error.4e385974.svg";